module.exports = __webpack_public_path__ + "img/puppy-what-we-do.d7b4f7ed.png";